import styled from "@emotion/styled";
import { Skeleton } from "@mui/material";
import { FlowButtons } from "components/NewOrders/NewOrders.styles";
import { RequestDateWrapper } from "components/Trucks/TruckShippingInfo/TruckShippingInfo.styles";

export const TruckDetailsWrapper = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: "16px",
	display: "flex",
	flexDirection: "column",
	gap: "16px"
}));

export const TruckDetailsHeader = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	p: {
		...theme.project.typography.subtitle.subtitle1,
		margin: 0,
		color: theme.project.colors.fontColors.secondary
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column"
	}
}));

export const TruckName = styled.div(({ theme }) => ({
	...theme.project.typography.heading.h6,
	color: theme.project.colors.fontColors.secondary
}));

export const TruckDetailsContent = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "24px"
}));

export const TruckDetailsSummary = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.tertiary,
	padding: "16px",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		justifyContent: "flex-start"
	}
}));

export const TruckDetailsSummarySkeleton = styled(Skeleton)(() => ({
	height: "40px"
}));

export const TruckDetailsSummaryDetails = styled.div(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "repeat(8, 1fr)",
	gap: "24px",
	[theme.breakpoints.down("md")]: {
		display: "flex",
		flexDirection: "column",
		gap: "16px"
	}
}));

export const TruckDetailsSummaryDetailsItem = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column"
}));

export const TruckDetailsSummaryRequestDate = styled(TruckDetailsSummaryDetailsItem)(({ theme }) => ({
	gridColumn: "span 1"
}));

export const TruckDetailsSummaryAccountNumber = styled(TruckDetailsSummaryDetailsItem)(({ theme }) => ({
	gridColumn: "span 3"
}));

export const TruckDetailsSummaryProductLine = styled(TruckDetailsSummaryDetailsItem)(({ theme }) => ({
	gridColumn: "span 1"
}));

export const TruckDetailsSummaryCabinetCount = styled(TruckDetailsSummaryDetailsItem)(({ theme }) => ({
	gridColumn: "span 1"
}));

export const TruckDetailsSummaryDetailsItemLabel = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.fontColors.main
}));

export const TruckDetailsSummaryDetailsItemValue = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary
}));

export const CubesAvailable = styled.div(({ theme }) => ({
	display: "flex",
	gridColumn: "span 2",
	flexDirection: "column",
	justifyContent: "flex-end",
	[theme.breakpoints.down("md")]: {
		justifyContent: "flex-start"
	}
}));

export const TruckDetailsSummaryNote = styled.div(({ theme }) => ({
	...theme.project.typography.caption,
	backgroundColor: theme.project.colors.backgroundColors.main,
	color: theme.project.colors.fontColors.secondary
}));

export const TruckNameWrapper = styled.div(({ theme }) => ({
	gridColumn: "span 4",
	paddingTop: "10px",
	paddingBottom: "10px",
	[theme.breakpoints.down("md")]: {
		padding: 0
	}
}));

export const EditTruckDetailsWrapper = styled.div(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "repeat(8, 1fr)",
	gap: "24px",
	// marginTop: "21px",
	[`${TruckNameWrapper}`]: {
		marginTop: "21px"
	},
	[`${RequestDateWrapper}`]: {
		marginTop: "21px",
		gridColumn: "span 4",
		width: "100%"
	},
	[`${TruckDetailsSummarySkeleton}:nth-of-type(1)`]: {
		gridColumn: "span 4"
	},
	[`${TruckDetailsSummarySkeleton}:nth-of-type(2)`]: {
		gridColumn: "span 4"
	},
	[`${TruckDetailsSummarySkeleton}:last-of-type`]: {
		gridColumn: "6 / span 3"
	},
	[theme.breakpoints.down("md")]: {
		display: "flex",
		gap: 0,
		flexDirection: "column",
		[`${RequestDateWrapper}`]: {
			marginTop: 0,
			gridColumn: "span 4",
			width: "100%"
		},
		[`${TruckDetailsSummarySkeleton}`]: {
			marginTop: "8px",
			marginBottom: "8px"
		}
	}
}));

export const EditTruckDetailsFlowButtons = styled(FlowButtons)(() => ({
	marginTop: 0
}));
